import { useCallback } from 'react';
import { useHubContext } from '@common/context/HubContext/HubContext';

/**
 * @returns a function that can be use to get the latest
 * information about a hub service. 
 */
const useHubServiceInfo = () => {
  const { services, isReady } = useHubContext();

  /**
   * @returns the latest information about a hub service or null if not found.
   */
  const getInfo = useCallback((serviceName: string, version: string) => {
    if (!isReady) {
      return null;
    }

    const match = services.available.find(s => s.name === serviceName && s.version === version);
    return match || null;
  }, [services, isReady]);

  return getInfo;
};

export default useHubServiceInfo;
